export type CompanyListStatistics = {
  total_companies: number;
  total_portfolios: number;
  total_assets: number;
  total_users: number;
};

export type CompanyStatistics = {
  compliance_score: number | null;
  compliance_score_level: "high" | "medium" | "low" | "insufficient";
  compliance_improvement: number | null;
  compliance_improvement_level: "up" | "down" | "flat" | "insufficient";
  avg_incidents_per_month: number | null;
  avg_incidents_level: "low" | "medium" | "high" | "no_data";
};

export type GeoCountry = {
  id: number;
  code: string;
  name: string;
};

export type GeoCountryListResponse = {
  items: GeoCountry[];
};

export type GeoCity = {
  id: number;
  name: string;
  country_id: number;
  country_name: string;
};

export type GeoCityListResponse = {
  items: GeoCity[];
  total: number;
  page: number;
  page_size: number;
};

export type EmirateCity = {
  id: number;
  name: string;
};

export type EmirateCityListResponse = {
  items: EmirateCity[];
};

export type CompanyItem = {
  id: number;
  name: string;
  country: {
    id: number;
    label: string;
  };
  city: {
    id: number;
    label: string;
  };
  created_at: string;
  owner: {
    id: number;
    full_name: string;
    position: string;
    email: string;
    phone: string;
  };
  portfolio_count: number;
  asset_count: number;
  user_count: number;
  risk_score: number | null;
  compliance_score: number | null;
};

export type CreateCompanyRequest = {
  company_name: string;
  country: string;
  city: string;
  full_name: string;
  email: string;
  phone: string;
  position: string;
};

export type CreateCompanyResponse = {
  id: number;
  name: string;
  country: string;
  city: string;
};

export type UpdateCompanyRequest = {
  company_name: string;
  country: string;
  city: string;
};

export enum UserStatuses {
  ACTIVE = "active",
  PENDING = "pending",
  INVITATION_EXPIRED = "invitation_expired",
}

export type UserItem = {
  company_id: number;
  company_name: string | null;
  email: string;
  full_name: string;
  id: number;
  is_owner: boolean;
  phone: string;
  position: string | null;
  status: UserStatuses;
  managed_portfolios_count: number;
};

export type UserFormValues = {
  name: string;
  email: string;
  phone: string;
  position: string;
  company?: string;
};

export type AddUserRequest = {
  full_name: string;
  email: string;
  phone: string;
  position: string;
};
